import { reactive, watch } from "vue";
import useAuth from "@/composables/useAuth";

const { isAuthenticated, state: authState } = useAuth();

const state = reactive({
  userId: authState.user ? authState.user.id : null, // Fetch user ID from useAuth state
  wishlist:
    JSON.parse(localStorage.getItem(`wishlist_${authState.user?.id}`)) || [],
});

const addItem = (item) => {
  if (isAuthenticated()) {
    if (item && !state.wishlist.some((wish) => wish.id === item.id)) {
      state.wishlist.push(item);
      localStorage.setItem(
        `wishlist_${state.userId}`,
        JSON.stringify(state.wishlist)
      );
    }
  } else {
    alert("You must be logged in to add items to the wishlist.");
  }
};

const removeItem = (index) => {
  state.wishlist.splice(index, 1);
  localStorage.setItem(
    `wishlist_${state.userId}`,
    JSON.stringify(state.wishlist)
  );
};

const getWishlistProperties = () => {
  return state.wishlist;
};

watch(
  () => state.wishlist,
  (newWishlist) => {
    localStorage.setItem(
      `wishlist_${state.userId}`,
      JSON.stringify(newWishlist)
    );
  },
  { deep: true }
);

export { state, addItem, removeItem, getWishlistProperties };
